import { implementsFunction } from "@thi.ng/checks/implements-function";
import { isArrayLike } from "@thi.ng/checks/is-arraylike";
import { isIterable } from "@thi.ng/checks/is-iterable";
import { illegalArity } from "@thi.ng/errors/illegal-arity";
import { isReduced, unreduced } from "./reduced.js";
const parseArgs = (args) => args.length === 2 ? [void 0, args[1]] : args.length === 3 ? [args[1], args[2]] : illegalArity(args.length);
function reduce(...args) {
  const rfn = args[0];
  const init = rfn[0];
  const complete = rfn[1];
  const reduce2 = rfn[2];
  args = parseArgs(args);
  const acc = args[0] == null ? init() : args[0];
  const xs = args[1];
  return unreduced(
    complete(
      implementsFunction(xs, "$reduce") ? xs.$reduce(reduce2, acc) : isArrayLike(xs) ? reduceArray(reduce2, acc, xs) : reduceIterable(reduce2, acc, xs)
    )
  );
}
function reduceRight(...args) {
  const rfn = args[0];
  const init = rfn[0];
  const complete = rfn[1];
  const reduce2 = rfn[2];
  args = parseArgs(args);
  let acc = args[0] == null ? init() : args[0];
  const xs = args[1];
  for (let i = xs.length; i-- > 0; ) {
    acc = reduce2(acc, xs[i]);
    if (isReduced(acc)) {
      acc = acc.deref();
      break;
    }
  }
  return unreduced(complete(acc));
}
const reduceArray = (rfn, acc, xs) => {
  for (let i = 0, n = xs.length; i < n; i++) {
    acc = rfn(acc, xs[i]);
    if (isReduced(acc)) {
      acc = acc.deref();
      break;
    }
  }
  return acc;
};
const reduceIterable = (rfn, acc, xs) => {
  for (let x of xs) {
    acc = rfn(acc, x);
    if (isReduced(acc)) {
      acc = acc.deref();
      break;
    }
  }
  return acc;
};
const reducer = (init, rfn) => [init, (acc) => acc, rfn];
const $$reduce = (rfn, args) => {
  const n = args.length - 1;
  return isIterable(args[n]) ? args.length > 1 ? reduce(rfn.apply(null, args.slice(0, n)), args[n]) : reduce(rfn(), args[0]) : void 0;
};
export {
  $$reduce,
  reduce,
  reduceRight,
  reducer
};
